import { LogOut } from "lucide-react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { DashboardPage } from "@/pages/DashboardPage.tsx";
import { LoginPage } from "@/pages/LoginPage.tsx";
import { TenantPage } from "@/pages/TenantPage.tsx";
import { useSession } from "@/stores/session.ts";

/** Solo con sesión completa (2FA configurado). */
function Protected() {
  const { token, requires2faSetup, clear } = useSession();
  if (!token || requires2faSetup) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
        <p className="font-semibold text-slate-900">
          Sistema Sale <span className="font-normal text-slate-500">· Plataforma</span>
        </p>
        <button
          type="button"
          onClick={clear}
          className="flex items-center gap-1 rounded-lg px-2 py-1 text-sm text-slate-600 hover:bg-slate-100"
        >
          <LogOut className="h-4 w-4" /> Salir
        </button>
      </header>
      <main className="mx-auto max-w-6xl p-6">
        <Outlet />
      </main>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Protected />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/tenants/:tenantId" element={<TenantPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
